import { createContext, type ReactNode, use, useMemo } from 'react';
import Shepherd from 'shepherd.js';

interface ShepherdContextType {
  Shepherd: typeof Shepherd;
}

const ShepherdJourneyContext = createContext<ShepherdContextType | undefined>(undefined);
const ShepherdJourneyContextConsumer = ShepherdJourneyContext.Consumer;

export const useShepherd = () => {
  const context = use(ShepherdJourneyContext);

  if (!context) {
    throw new Error('useShepherd must be used within a ShepherdJourneyProvider');
  }

  const { Shepherd: ShepherdInstance } = context;

  return ShepherdInstance;
};

export const ShepherdJourneyProvider = ({ children }: { children?: ReactNode }) => {
  const value = useMemo(() => {
    return { Shepherd };
  }, []);

  return <ShepherdJourneyContext value={value}>{children}</ShepherdJourneyContext>;
};

// For backwards compatibility, we're also exporting consumer and context
export { ShepherdJourneyContextConsumer as JourneyMethods, ShepherdJourneyContext };
